<mat-form-field [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>

  <mat-select [formControl]="providerControl" [compareWith]="compareProviders" [placeholder]="placeholder">
    <mat-select-trigger>
      {{ providerControl.value?.lastName }}, {{ providerControl.value?.firstName }}
    </mat-select-trigger>

    <mat-option *ngIf="showAll" [value]="'ALL'">--- All ---</mat-option>

    <mat-option *ngIf="providers.length === 0" disabled>Loading providers...</mat-option>

    <mat-option *ngFor="let provider of providers" [value]="provider">
      <div class="provider-option">
        <div class="provider-name">
          {{ provider.lastName }}, {{ provider.firstName }}
          <mat-chip *ngIf="provider?.hasLicense !== undefined && !provider?.hasLicense" class="small-mat-chip"
            >No License</mat-chip
          >
        </div>
        <div class="provider-languages" *ngIf="showLanguages && provider.languages?.length">
          <small>{{ languagesLabel }}: {{ provider.languages.join(', ') }}</small>
        </div>
      </div>
    </mat-option>
  </mat-select>

  <mat-hint *ngIf="showHint">{{ hint }}</mat-hint>

  <mat-error *ngIf="providerControl?.invalid">
    {{ errorMessage }}
  </mat-error>
</mat-form-field>
